class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length>0){
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = false;
        });
      }else{
        document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
          SeachButtons.disabled = true;
        });
      }
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    var searchtype = $('.snippet-search-bar').attr('data-searchtype');
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=${searchtype}&resources[limit]=10&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) {
        this.close();
      }else{
        this.open();
      }
      let prod_grid = document.querySelectorAll('.search-column.hide_product')
      prod_grid.forEach((prod) => {
        if(document.cookie.indexOf('SecureCollection') != -1){
          prod.style.display = 'block';
        }else{
          prod.style.display = 'none';
        }
      })
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }
      if(document.getElementById('SearchValueMob')){
        document.getElementById('SearchValueMob').value = searchTerm;
      }
      $('.search-slider').flickity({pageDots: false,cellAlign:"left",contain:true});
      $(".grid-meta").matchHeight({property:"height"});
      var thisData = $('.search-slider');
      var flktycarousel = thisData.data('flickity');
      var lastCell = false,firstCell=false;
      flktycarousel.on('cellSelect', function(){
        var friction = (flktycarousel.options['friction'] + 0.1) * 1000;
        setTimeout(function(){
          var fullSize = flktycarousel.slideableWidth,
              viewport = flktycarousel.size['width'],
              cellWidth = flktycarousel.selectedSlide['outerWidth'],
              movedX = Math.round(flktycarousel.x);
          fullSize = Math.round(fullSize);
          cellWidth = Math.round(cellWidth);
          movedX = Math.abs(movedX);
          var total = Math.round((viewport + movedX) / 100) * 100,
              fullSize = Math.round(fullSize / 100) * 100;
          thisData.find('.flickity-prev-next-button.next').prop('disabled', false);
          if(total >= fullSize){
            if(lastCell == true)
              //flktycarousel.select(0);
              lastCell = true;
            if(lastCell == true){
              thisData.find('.flickity-prev-next-button.next').prop('disabled', true);              
            }
            thisData.addClass('lastspace');
            thisData.find('.flickity-prev-next-button.next').prop('disabled', true);
          }else{
            thisData.removeClass('lastspace');
          }
          firstCell=false;
          thisData.removeClass('firstspace');
          if(movedX < 70){
            lastCell = false;
            firstCell = true;
            thisData.addClass('firstspace');       
          }
        }, friction);
      });
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    $('.section-header').addClass('default-header');
    $('body').addClass('desk-search-body');
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
    $('.section-header').removeClass('default-header');
    $('body').removeClass('desk-search-body');    
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
var header_height = $('.header-outer').innerHeight();
$('#predictive-search').css({"top": header_height, "height": "calc(100% - "+header_height+"px)"});  
$('body').on('click',function(e){   
  var seachbox = $(".searchlist,#predictive-search-results,.mobile-serachbox");    
  if (!seachbox.is(e.target) && seachbox.has(e.target).length === 0){
    $('body').removeClass('desk-search-body');
    $('.snippet-search-bar input').val('');
    $('#predictive-search').hide();   
  }
});
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    $('body').removeClass('open-search');
  });
});
$('.close-menu').on('click',function(e){
  $('.navmobile-dropdown,.bottom-details').removeClass('active');
  $('.snippet-menu-drawer').removeClass('hidescroll');
  $('.m-secondpart').removeClass('hide-sec-part');
});
$('.searchmicon').on('click',function(e){
  e.preventDefault();
  $('body').addClass('open-search');
  $('body').removeClass('open-menu');
  $("#s-search").focus();
  $('.section-header').addClass('default-header');
});
$('.closemicon').on('click',function(e){
  e.preventDefault();
  $('body').removeClass('open-search');
  $('body').removeClass('open-menu desk-search-body');
});
$('.mob-newslist').each(function(e){
  var data_drgable = $(this).data('draggable');
  $(this).flickity({wrapAround: true,pageDots: true,contain:true,autoPlay: false,cellAlign:"left",draggable: data_drgable});
});
$('.nav-arrow').on('click',function(e){
  e.preventDefault();
  $(this).closest('.nav-wrap').next('.navmobile-dropdown').addClass('active').parent('li').siblings().find('.navmobile-dropdown').removeClass('active');
  if($('.navmobile-dropdown.active').length>0){
    $('.snippet-menu-drawer').addClass('hidescroll');
  }else{
    $('.snippet-menu-drawer').removeClass('hidescroll');
  }
  $(".snippet-menu-drawer").animate({ scrollTop: 0 }, 2);
});
$('.first-mobile-nav .back-menu').on('click',function(e){
  e.preventDefault();
  $(this).closest('.navmobile-dropdown').removeClass('active');
  if($('.navmobile-dropdown.active').length>0){
    $('.snippet-menu-drawer').addClass('hidescroll');
  }else{
    $('.snippet-menu-drawer').removeClass('hidescroll');
  }
  $(".snippet-menu-drawer").animate({ scrollTop: 0 }, 2);
});
$('.localist li').on('click',function(e){
  e.preventDefault();
  $('.active-localization').text($(this).find('.top-svg').text());
});
$('.currencysave').on('click',function(e){
  e.preventDefault();
  $(this).closest('.currency-mob-form').find('form').submit();
  $('.m-secondpart').removeClass('hide-sec-part');
  $('.bottom-details').removeClass('active');
});
$('.back-menu').on('click',function(e){
  e.preventDefault();
  $(this).closest('.bottom-details').removeClass('active');
  $('.m-secondpart').removeClass('hide-sec-part');
});
$('.mob-loc-buttons').on('click',function(e){
  e.preventDefault();
  $('.bottom-details').removeClass('active');
  $('.bottom-details[data-title="'+$(this).data('title')+'"]').addClass('active');
  $(".snippet-menu-drawer").animate({ scrollTop: 0 }, 2);
  $('.m-secondpart').addClass('hide-sec-part');
});
$('.currencysave,.blurdiv-menu').on('click',function(e){
  e.preventDefault();
  $('body').removeClass('open-menu');
  $('.m-secondpart').removeClass('hide-sec-part');
});
$('.account-tab').on('click',function(e){
  $(this).addClass('active').siblings().removeClass('active');
  var cuurent_tab = $(this).data('type');
  $('.account-tab-content[data-type="'+cuurent_tab+'"]').addClass('active').siblings().removeClass('active');
  setTimeout(function(){
    $('.account-tab-content[data-type="'+cuurent_tab+'"]').find('.account-slide').addClass('active').parent().siblings().find('.account-slide').removeClass('active');
  },10);
});
$(document).on('click','.forgot-button',function(e){
  e.preventDefault();
  $('.login-wrap').hide();
  $('.forgot-wrap').show();
});
$(document).on('click','.enable-login',function(e){
  e.preventDefault();
  $('.login-wrap').show();
  $('.forgot-wrap').hide();
});
$("#remember").click(function () {
  if ($(this).is(":checked")) {
    var username = $('#CustomerEmail').val();
    var password = $('#CustomerPassword').val();
    $.cookie('rusername', username, { expires: 14 });
    $.cookie('rpassword', password, { expires: 14 });
    $.cookie('rremember', true, { expires: 14 });
  } else {
    $.cookie('rusername', null);
    $.cookie('rpassword', null);
    $.cookie('rremember', null);
  }
});
var remember = $.cookie('rremember');
if ( remember == 'true' ) {
  var username = $.cookie('rusername');
  var password = $.cookie('rpassword');
  $('#CustomerEmail').val(username);
  $('#CustomerPassword').val(password);
}
$(function(){
  $('.registerbtn').on('click',function(e) {   
    if ($('#RegisterForm-password').val() != $('#RegisterForm-r_password').val()){
      e.preventDefault();
      $('.notmatchpassword').show();      
    }else{      
      $('.notmatchpassword').hide();
      if($('#RegisterForm-email').val() != '' && $('#RegisterForm-password').val() != '' && $('#RegisterForm-r_password').val() != '' && $('#RegisterForm-FirstName').val() != ''  && $('#RegisterForm-LastName').val() != '' && $('#RegisterForm-Country').val() != '' && $('#RegisterForm-DateOfBirth').val() != '' ){
        $('#create_customer').submit();
      }     
    }
  });
});
$('.account-drawer .another-account a').on('click',function(e){
  e.preventDefault();
  $('.account-tab[data-type="register"]').trigger('click');
});
$('.account-drawer .another-login a').on('click',function(e){
  e.preventDefault();
  $('.account-tab[data-type="sign-in"]').trigger('click');
});
$(document).on('click','.h-accountbtn',function(e){
  e.preventDefault();
  $('body').addClass('open-account');
});
$(document).on('click','.overlay-box',function(e){
  e.preventDefault();
  $('body').removeClass('open-account');
});
$('.account-mob-close').on('click',function(e){
  $('body').removeClass('open-account');
  $('[data-type="register"],[data-type="register"] .account-slide').removeClass('active');
  $('[data-type="sign-in"],[data-type="sign-in"] .account-slide').addClass('active');
  $('.forgot-wrap').hide();
  $('.login-wrap').show();
});
$(document).on('click','.customer-logout .close-blackbar',function(e){
  $('.customer-logout').removeClass('active');
  $.cookie('logoutcustomer', null);
});
$('.countryLink').on('click',function(e){
  e.preventDefault();
  $(this).closest('form').submit();
});
document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});
if(document.querySelector('.list-menu > li')){
  document.querySelectorAll('.list-menu > li').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
      $('.section-header,.section-header-unite').addClass('default-header');
      $('body').addClass('desk-overlaymenu');
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
      if($(window).scrollTop()>100){
        $('.section-header-unite').removeClass('default-header');
      }else{
        $('.section-header,.section-header-unite').removeClass('default-header');
      }
      $('body').removeClass('desk-overlaymenu');
    });
  });
}
$('.daily-dropdown').each(function(e){
  var droplist = $(this);
  $(this).find('.custom-dropdown').after("<ul class='convert-dropdown' />").children("option").each(function() {
    droplist.find('.convert-dropdown').append('<li data-text="'+$(this).text()+'" data-value="'+$(this).val()+'">'+$(this).text()+"</li>");
  }).end().remove();
  $('.drop-first-text').text($('.convert-dropdown li:nth-child(2)').text());
});
$(document).on('click','.convert-dropdown li',function(e){
  var current_selectlist = $(this).data('value');
  $(this).addClass('active').siblings().removeClass('active');
  $(this).closest('.daily-dropdown').find('input').attr('value',current_selectlist);
  $(this).closest('.daily-dropdown').find('input').focus();
  $(this).closest('.daily-dropdown').find('.drop-selected .drop-first-text').text(current_selectlist);
  $('.border-dropdown').hide();
});
$(document).on('click','.daily-dropdown-box input[type="text"]',function(e){
  $(this).closest('.daily-dropdown').find('.border-dropdown').show();
});
$(document).on('click','.drop-selected',function(e){
  $(this).closest('.daily-dropdown').find('.border-dropdown').hide();
});
if($('.credit-header').length>0){
  $('.credit-header').on('click',function(e){
    $('.creadit-droplist').slideToggle();
    $(this).toggleClass('active');
  });
}
function swymCallbackFn() {
  window._swat.fetch( function(r) {
    if(r.length>0){
      $('.favorite-header').addClass('active');
    }else{
      $('.favorite-header').removeClass('active');
    }
  });
}
function accordian(){
  $(document).on('click','.accordian-title',function(e){
  	$(this).next('.accordian-content').slideToggle();
    $(this).toggleClass('active');
    $(this).closest('.accordian-wrap').siblings('.accordian-wrap').find('.accordian-content').slideUp();
    $(this).closest('.accordian-wrap').siblings('.accordian-wrap').find('.accordian-title').removeClass('active');
  });
}
function flickityScroll(thisData){
  var flktycarousel = thisData.data('flickity');
  var lastCell = false,firstCell=false;
  flktycarousel.on('cellSelect', function(){
    var friction = (flktycarousel.options['friction'] + 0.1) * 1000;
    setTimeout(function(){
      var fullSize = flktycarousel.slideableWidth,
          viewport = flktycarousel.size['width'],
          cellWidth = flktycarousel.selectedSlide['outerWidth'],
          movedX = Math.round(flktycarousel.x);
      fullSize = Math.round(fullSize);
      cellWidth = Math.round(cellWidth);
      movedX = Math.abs(movedX);
      var total = Math.round((viewport + movedX) / 100) * 100,
          fullSize = Math.round(fullSize / 100) * 100;
      thisData.find('.flickity-prev-next-button.next').prop('disabled', false);
      if(total >= fullSize){
        if(lastCell == true)
          //flktycarousel.select(0);
          lastCell = true;
        if(lastCell == true){
          thisData.find('.flickity-prev-next-button.next').prop('disabled', true);
          console.log('d',lastCell);
        }
        thisData.addClass('lastspace');
        thisData.find('.flickity-prev-next-button.next').prop('disabled', true);
      }else{
        thisData.removeClass('lastspace');
      }
      firstCell=false;
      thisData.removeClass('firstspace');
      if(movedX < 70){
        lastCell = false;
        firstCell = true;
        thisData.addClass('firstspace');       
      }
    }, friction);
  });
}
$('.product-carousel').each(function(e){
  var thisslider = $(this);
  $(this).flickity({pageDots: false,cellAlign:"left",contain:true}); 
  flickityScroll(thisslider);
});
accordian();
document.addEventListener("shopify:section:load", function(event) {
  accordian();
});
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
/*$(".mega-main-grid").matchHeight({property:"height"});*/